module.exports = (s) => {
  return {
    name: {
      label: '标题名称',
      type: 'input',
      value: '',
      rules: [
        { required: true,
          trigger: ['change'],
          message: '请输入标题名称',
        },
        {
          required: true,
          message: `标题名称最大长度为${s.pageConfig.rules.max_length}个字`,
          trigger: ['change'],
          validator: (rule, value, callback) => {
            if (value?.length <= s.pageConfig.rules.max_length) {
              callback();
            } else {
              callback(new Error(rule.message));
            }
          },
        },
      ],
      props: {
        showWordLimit: true,
        maxlength: s.pageConfig.rules.max_length,
      },
    },
  };
};
